<script>
import {getAction, httpAction, postAction} from "@/utils/api/manages";

export default {
  name: "comments",
  props: {
    productMainTypeId: String,
  },
  created() {
    this.getCommentsList()
  },
  watch: {
    productMainTypeId(val) {
      this.getCommentsList()
    }
  },
  data() {
    return {
      commentsList: [],
      isLoading: false,
      isLogin: localStorage.getItem("showLogin"),
      // 是否下拉
      isDrop: false,
    }
  },
  methods: {
    getCommentsList() {
      this.isLoading = true
      let data = {
        productMainType: this.productMainTypeId
      }
      if (localStorage.getItem("authdata")) {
        const userInfo = JSON.parse(localStorage.getItem("authdata"))
        const {userId} = userInfo.data
        data.userId = userId
      } else {
        data.userId = ''
      }
      getAction('/productcomment/data/getTop', data).then(res => {
        this.commentsList = res.data
      }).finally(() => {
        this.isLoading = false
      })
    },
    // 添加好友
    addFriends(item) {
      const isLogin = localStorage.getItem("showLogin")
      if (isLogin === '0') {
        layer.alert('请先登录', {icon: 6})
        return
      }
      const userInfo = JSON.parse(localStorage.getItem("authdata"))
      const {userId} = userInfo.data
      const applyTargetUserid = item.userId
      const data = {
        applyTargetUserid,
        userid: userId,
        content: ''
      }
      postAction('/message/applyfirends', data).then(res => {
        layer.alert('加好友申请成功！<br/>留意系统通知耐心等待通过', {icon: 6})
      }).catch(res => {
        layer.alert(res.msg)
      })
    },
    // 消息
    sendMessage(item) {
      const {userId, realName, avatar} = item
      const authData = localStorage.getItem("authdata")
      if (!authData) {
        $("#loginModal").modal("show");
        return
      }
      try {
        messagefriends(null, userId, realName, avatar);
      } catch {
        this.$message.error('系统内部错误，请稍后再试！')
      }
    },
    // 关注
    addFollow(item) {
      this.follow('/message/applyfollow', item).then(res => {
        this.$message.success('关注成功！')
        this.getCommentsList()
      })
    },
    // 取消关注
    cancelFollow(item) {
      this.follow('/message/cancelfollow', item).then(res => {
        this.$message.success('取消关注成功！')
        this.getCommentsList()
      })
    },
    follow(url, item) {
      let authData = localStorage.getItem("authdata")
      if (!authData) {
        $("#loginModal").modal("show");
        return
      }
      authData = JSON.parse(authData)
      const data = {
        "followUserid": item.userId,
        "userid": authData.data.userId
      }
      return httpAction({
        url,
        method: 'post',
        headers: {
          "username": localStorage.getItem("username"),
          "Authorization": "Api_Bearer " + localStorage.getItem("token"),
        },
        data
      })
    },
    seeDetails(item) {
      const {userId} = item
      const isLogin = localStorage.getItem("showLogin")
      if (isLogin === '0') {
        this.$message.warning('请先登录！')
        return
      }
      this.$router.push({path: '/personal-index', query: {id: userId}})
    }
  }

}
</script>

<template>
  <div>
    <div class="comments" v-loading="isLoading">
      <div class="comments-head">
        <div class="title">点评达人</div>
      </div>
      <div class="comments-body">
        <template v-if="commentsList.length">
          <div class="card" v-for="(item, index) in commentsList" :key="index" @click="seeDetails(item)">
            <div class="cornerMarkers" :class="'icon'+(index+1)" v-if="index<3"></div>
            <div class="cornerMarkers icon4" v-else>
              {{ index + 1 }}
            </div>
            <div class="cardBody">
              <el-badge :value="`评论数：${item.num}`" class="numOfCom"></el-badge>
              <div class="info-left">
                <div class="imgBox" :class="item.isOnline === 1 ? 'isOnline' : null">
                  <el-image
                      :src="item.avatar" v-if="item.avatar" fit="cover"
                      style="height: 100%;width: 100%;"></el-image>
                  <el-image src="http://images.qidao123.com/static/user.png" v-else></el-image>
                </div>
                <div class="address fa fa-map-marker ellipsis">
                  {{ item.companyAreaNames ? item.companyAreaNames.split(',').at(-1) : '暂无' }}
                </div>
              </div>
              <div class="info-right">
                <div class="info-head">
                  <h4 class="name">{{ item.realName.at(0) + '＊＊' }}</h4>
                  <div class="jia job"
                       v-if="item.usertype === 0
                     && item.identityType !== 0
                     &&  item.identityType !== 3">
                    甲
                  </div>
                  <div class="job yi" v-if="item.usertype === 1">乙</div>
                  <div class="job yi" v-if="item.usertype === 1 && item.identityType === 2">
                    企
                  </div>
                  <div class="job nan" v-if="item.identityType === 3">三</div>
                  <div class="job nv" v-if="item.identityType === 0">管</div>
                  <div class="job nan" v-if="item.sex === 1">男</div>
                  <div class="job nv" v-else>女</div>
                  <div class="fa fa-user-circle-o icon grey p0"
                       aria-hidden="true"
                       title="未实名"
                       v-if="item.isCertified === 0"></div>
                  <div class="fa fa fa-user-circle-o blue icon" title="已实名" v-else></div>
                  <div class="fa fa-vimeo-square icon grey p0"
                       title="非会员" v-if="item.isvip === 0"
                       aria-hidden="true"></div>
                  <div class="fa fa-vimeo-square icon blue" v-else title="会员" aria-hidden="true"></div>
                  <div class="fa fa-user-plus icon grey p0" v-if="item.isJobCertification === 0" title="未认证"
                       aria-hidden="true"></div>
                  <div class="fa fa-user-plus icon pink" v-else title="已认证" aria-hidden="true"></div>
                </div>
                <div class="info-body">
                  <div class="company ellipsis" :title="item.companyName + '/' + item.userPost">
                    <template v-if="isLogin === '1'">
                    <span>{{
                        item.companyName.length < 8 ? item.companyName :
                            item.companyName.slice(0, 8) + '...'
                      }}</span>
                    </template>
                    <template v-else>
                    <span>
                      {{
                        item.companyName ? item.companyName.substring(0, 2) + '＊＊＊＊' :
                            "暂无"
                      }}
                    </span>
                    </template>
                  </div>
                  <span class="job-tag ellipsis" v-if="item.userPost">{{ item.userPost }}</span>
                </div>
                <div class="info-footer">
                  <div class="buttonGroups">
                    <div class="myBtn" @click="sendMessage(item)">消息</div>
                    <div
                        class="myBtn setBorder"
                        v-if="item.isFriend === 0"
                        @click="addFriends(item)"
                    >好友
                    </div>
                    <div class="myBtn setBorder" v-else-if="item.isFriend === 11">已申请好友</div>
                    <div class="myBtn setBorder" v-else>已加好友</div>
                    <div class="myBtn" @click="addFollow(item)" v-if="item.isFollow === 0">
                      关注
                    </div>
                    <div class="myBtn" v-else @click="cancelFollow(item)">取消关注</div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </template>
        <div class="empty" v-else>暂无内容</div>
      </div>
    </div>
  </div>

</template>

<style scoped lang="scss">
.comments {
  padding: 15px;
  background: #f2f2e5;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 20px;

  .ellipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .myBtn {
    cursor: pointer;
    color: var(--swiper-theme-color);
  }

  .comments-head {
    display: flex;
    justify-content: space-between;
    position: relative;
    align-items: center;
    margin-bottom: 10px;

    &:after {
      content: '';
      display: block;
      height: 100%;
      width: 4px;
      position: absolute;
      left: 0;
      background-color: var(--swiper-theme-color);
      border-radius: 4px;
    }

    .title {
      font-size: 16px;
      color: #232f3e;
      padding-left: 15px;
    }
  }

  .comments-body {
    display: flex;
    flex-direction: column;
    gap: 17px;
    max-height: 570px;
    overflow: auto;
    padding-top: 13px;
    scrollbar-color: #8B8B8B transparent;
    padding-right: 10px;
    margin-right: -10px;


    .card {
      display: flex;
      gap: 5px;

      .cornerMarkers {
        height: 20px;
        background-size: 20px;
        background-repeat: no-repeat;
        text-align: center;
        width: 20px;
        line-height: 20px;
        font-size: 11px;
        color: #FFFFFF;

        &.icon1 {
          background-image: url('http://images.qidao123.com/static/reg@2x(24).png');
        }

        &.icon2 {
          background-image: url('http://images.qidao123.com/static/reg@2x(25).png');
        }

        &.icon3 {
          background-image: url('http://images.qidao123.com/static/reg@2x(26).png');
        }

        &.icon4 {
          background-image: url('http://images.qidao123.com/static/reg@2x(27).png');
        }
      }

      .cardBody {
        flex: 1;
        flex-shrink: 0;
        position: relative;
        background-color: #ffff;
        padding: 10px;
        display: flex;
        gap: 10px;
        border-radius: 6px;
        border: 1px solid transparent;
        cursor: pointer;

        &:hover {
          border-color: rgb(2, 98, 241);
        }

        .numOfCom {
          position: absolute;
          transform: translateY(-110%);

          &::v-deep(.el-badge__content) {
            border-radius: 0 10px 10px 0;
            top: 0;
            left: -11px;
          }
        }

        .info-left {
          width: 50px;

          .imgBox {
            width: 100%;
            height: 50px;
            box-sizing: border-box;
            border-radius: 50px;
            overflow: hidden;
            border: 2px solid #e9e9e9;

            &.isOnline {
              border-color: rgb(56, 189, 133);
            }
          }

          .address {
            font-size: 12px;
            color: #999;
            margin-top: 10px;
            width: 100%;
            overflow: hidden;
          }
        }

        .info-right {
          flex: 1;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          gap: 10px;

          .info-head {
            display: flex;
            gap: 2px;
            align-items: center;

            .name {
              padding-right: 5px;
              font-weight: 700;
            }

            .job {
              height: 14px;
              width: 14px;
              color: white;
              font-size: 10px;
              border-radius: 5px;
              text-align: center;
              line-height: 16px;

              &.jia {
                background-color: rgb(255, 215, 0);
              }

              &.yi {
                background-color: #24cdde;
              }

              &.nan {
                background-color: rgb(20, 107, 216);
              }

              &.nv {
                background-color: rgb(255, 146, 139);
              }
            }

            .icon {
              font-size: 12px;
              color: white;
              border-radius: 16px;
              padding: 2px;

              &.grey {
                color: rgba(35, 47, 62);
                opacity: .5;
              }

              &.blue {
                background-color: #6f9af3;
              }

              &.p0 {
                padding: 0;
                font-size: 14px;
                line-height: 12px
              }

              &.pink {
                background-color: #eb5412;
                opacity: .5;
              }
            }
          }

          .info-body {
            display: flex;
            gap: 10px;

            .company {
              max-width: 90px;
              font-size: 12px;
              flex-shrink: 0;
            }

            .job-tag {
              color: #9a846b;
              margin-left: 2px;
              border-radius: 2px;
              font-size: 11px;
              border: 1px solid #cabeb2;
              padding: 0 2px;
              max-width: 60px;
            }
          }

          .info-footer {
            border-top: 2px solid #e9e9e9;

            .buttonGroups {
              display: flex;

              .myBtn {
                flex: 1;
                text-align: center;
                font-size: 12px;
                padding: 5px 0 0;

                &.setBorder {
                  border-left: 2px solid #eee;
                  border-right: 2px solid #eee;
                }
              }
            }
          }
        }
      }
    }
  }

  .empty {
    text-align: center;
    line-height: 40px;
    color: #999999;
    margin-top: -20px;
  }
}

.arrow {

  .pull-img {
    width: 20px;
    height: 20px;
    display: block;
    margin: 20px auto;
    cursor: pointer;

    &.pull-down {
      animation: bounce-down 2s infinite;
    }

    &.pull-up {
      animation: bounce-up 2s infinite;
    }
  }
}


@keyframes bounce-up {
  0%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-15px);
  }
}

@keyframes bounce-down {
  0%, 100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(20px);
  }

  60% {
    transform: translateY(25px);
  }
}
</style>